import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';
import Hosts from '../../Hosts'
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../UseToken';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,
	repo_banner_link,

	pattern_vat,
	pattern_email,
	passwordHash,

} from '../../Utils';

import { language } from './Language';
import { color } from "../WEBContent/Color";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import endOfDecadeWithOptions from 'date-fns/esm/fp/endOfDecadeWithOptions';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	const [is_edit, set_is_edit] = useState(false)
	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])
	const [hours, setHours] = useState(null)
	const [minutes, setMinutes] = useState(null)

	const tableStyle = {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: "14px",
		color: color.cor1.hexa,
		textAlign: "left",
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: '#fff',
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.cor2.rgb,
		textTransform: 'uppercase',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: color.cor3.hexa,
	};

	const tarefasCellStyle = {
		...cellStyle,
		textAlign: 'left',
		fontWeight: '500',
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
		'&:hover': {
			backgroundColor: '#f0f0f0',
		},
	};

	const hoverEffect = {
		'&:hover': {
			backgroundColor: '#f0f0f0',
			boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
		},
	};

	const ulStyle = {
		listStyleType: 'none',
		padding: 0,
		margin: 0,
		lineHeight: '1.8',
	};

	const liStyle = {
		padding: '5px 0',
		color: color.cor1.hexa,
	};

	// Nome:Tipo
	const tipoSw = [
		{ id: 1, nome: 'SimAlimentação' },
		{ id: 2, nome: 'SimPan' },
		{ id: 3, nome: 'SimFact' },
		{ id: 4, nome: 'SimBeet' },
		{ id: 5, nome: 'SimRest' }
	];

	//Linha:SW
	const linhaSw = [
		{ id: 1, nome: 'Base' },
		{ id: 2, nome: 'Extra' },
		{ id: 3, nome: 'Light' },

	];

	const tipoPagamento = [
		{ id: 1, nome: 'Vulso' },
		{ id: 2, nome: 'Numero de horas' },
	];

	const [empresa, setEmpresa] = useState([]);
	const [projetos, setProjetos] = useState([]);

	// STATES PARA PROJETOS
	const [codProjetoInput, setCodProjetoInput] = useState("");
	const [nLicencaInput, setNLicencaInput] = useState("");
	const [selectedEmpresa, setSelectedEmpresa] = useState("");
	const [tempoAssistenciaInput, setTempoAssistenciaInput] = useState("");
	const [assistenciaRemotaInput, setAssistenciaRemotaInput] = useState(false);
	const [assistenciaPermitidaInput, setAssistenciaPermitidaInput] = useState(false);
	const [assistenciaMensal, setAssistenciaMensal] = useState({})
	const [tipoIdInput, setTipoIdInput] = useState(dados.current.info?.nome[0]?.tipo || "");
	const [linhaIdInput, setLinhaIdInput] = useState(dados.current.info?.nome[0]?.linha || "")
	const [tipoProjeto, setTipoProjeto] = useState(dados.current.info?.tipo || "")
	const [assistencia, setAssistencia] = useState([])

	const [adicionaMais, setAdicionaMais] = useState(false)
	//const [tipoIdInput, setTipoIdInput] = useState("");
	//const [linhaIdInput, setLinhaIdInput] = useState("");
	const [datePublishedInput, setDatePublishedInput] = useState("");
	const [dateAvailableInput, setDateAvailableInput] = useState("");
	const [dateCreationInput, setDateCreationInput] = useState("");
	const [dateModifiedInput, setDateModifiedInput] = useState("");


	const [dataInicio, setDataInicio] = useState("");
	const [dataFim, setDataFim] = useState("");

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				const tempoAssistenciaCompleto = res.data[0].info.assistenciaMensal
				console.log("tempo de assistencia", tempoAssistenciaCompleto)

				const horas = Math.floor(tempoAssistenciaCompleto / 60)
				const minutos = tempoAssistenciaCompleto % 60

				setHours(horas)
				setMinutes(minutos)
				setAssistencia(res.data[0].info.assistenciaMensal || "")
				console.log("Assistencia no res", assistencia)
				setTempoAssistenciaInput(tempoAssistenciaCompleto)

				setTipoProjeto(res.data[0].info.tipoProjeto || "");
				setCodProjetoInput(res.data[0].info.codProjeto || "");
				setNLicencaInput(res.data[0].info.nLicenca || "");
				setSelectedEmpresa(res.data[0].info.empresa || "");
				setTempoAssistenciaInput(res.data[0].info.tempoAssistencia || "");

				setAssistenciaRemotaInput(res.data[0].info.assistenciaRemota || false);
				setAssistenciaPermitidaInput(res.data[0].info.assistenciaPermitida || false);
				setTipoIdInput(res.data[0].info.nome[0].tipo || "");
				setLinhaIdInput(res.data[0].info.nome[0].linha || "");
				setDatePublishedInput(res.data[0].info.date[0].published || "");
				setDateAvailableInput(res.data[0].info.date[0].available || "");
				setDateCreationInput(res.data[0].info.date[0].creation || "");
				setDateModifiedInput(res.data[0].info.date[0].modified || "");

				//console.log(res.data[0].info.nome[0].tipo)

				set_dados(dados.current = res.data[0]);
				//console.log("Dados", res.data)

			})
			.catch(error => alert(error))
	}
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		console.log("22222", dados.current.info?.assistenciaMensal)
		const fetchEntities = async () => {
			try {
				const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
				// Filtra as entidades com entity_type === "2" e mapeia para guardar somente nome e id
				const entitiesOptions = res.data
					.filter(entity => entity.entity_type === "2")
					.map(entity => ({
						id: entity.id,
						nome: entity.name
					}));

				setEmpresa(entitiesOptions);
				//console.log("Entities:", entitiesOptions); // Vai exibir apenas o id e nome
			} catch (error) {
				console.error("Erro:", error);
			}
		};

		const fetchProjetos = async () => {

			try {
				const res = await reqGET(`${Hosts.SIMCore_API}/intranet/projetos/${getTokenInfo().companycode}`);
				const projetosOptions = res.data.map(projeto => ({
					id: projeto.id,
					name: projeto.info.nome[0]?.nomeCompleto || '',
					empresa: projeto.info.empresa,
				}));

				//console.log('Projetos', projetosOptions);
				setProjetos(projetosOptions);

			} catch (error) {
				console.error("Erro ao buscar os tipos de utilizadores:", error);
			}
		};

		fetchEntities();
		fetchProjetos();
	}, []);

	useEffect(() => {
		clean_data();
		obter_paises_em_pt(set_countries);

		if (getTokenInfo().profile === 'Cliente') {
			set_is_edit(true)
			set_show_delete_button('d-none')
			fetch_id_info(getTokenInfo().id).then(() => {
				if (dados.current.addresses[0].country === 'Portugal') {
					obter_distritos_pt(set_districts)
					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {


				set_is_edit(true)
				set_show_delete_button('')
				fetch_id_info(props.location.state.item['id']).then(() => {


					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {
						obter_distritos_pt(set_districts)
						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}

					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		}
		catch {

			clean_data()
			setLoading(false);
			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	function getNomeByIds(tipoId, linhaId) {
		const tipo = tipoSw.find(t => t.id === tipoId);
		const linha = linhaSw.find(l => l.id === linhaId);

		if (tipo && linha) {
			return `${tipo.nome} ${linha.nome}`;
		} else {
			return language[lang].type_error;
		}
	}

	const adicionarAssistencia = () => {

		const novosDados = generateAssistenciaMensal(tempoAssistenciaInput);


		setAssistencia((prevAssistencia) => {

			const assistenciaAtualizada = [...prevAssistencia];

			novosDados.forEach((novo) => {
				const existe = assistenciaAtualizada.some(
					(existente) => existente.ano === novo.ano && existente.mes === novo.mes
				);
				if (!existe) {
					assistenciaAtualizada.push(novo);
				}
			});

			return assistenciaAtualizada;
		});

		// Limpa os campos
		setHours("");
		setMinutes("");
		setTempoAssistenciaInput("");
		setDataFim("");
		setDataInicio("");
	};

	const change_lang = (l) => {
		//set_language(l)
		set_lang(l)
		window.location.reload()

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	useEffect(() => {

		//set_lang('pt')
		//set_lang_id('1')

		//get_fact_legacy_info()
		//get_fact_legacy_info()

		if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
			change_lang('pt')
		}
		else {
			set_lang(localStorage.getItem('lang'))
			console.log("estamos a alterar para", lang)
		}

		setLoading(false)

	}, [props])


	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!codProjetoInput || !nLicencaInput || !selectedEmpresa || !tipoIdInput || !linhaIdInput) {
			Swal.fire({
				title: language[lang].insert_error,
				icon: 'error',
				confirmButtonColor: color.corVerde.rgb2,
			});
			return;
		}

		const currentDateTime = new Date().toISOString();

		const creationDate = is_edit ? dateCreationInput : currentDateTime;

		const formData = {
			codProjeto: codProjetoInput,
			nLicenca: nLicencaInput,
			empresa: selectedEmpresa,
			//tempoAssistencia: tempoAssistenciaInput,
			assistenciaRemota: assistenciaRemotaInput,
			assistenciaPermitida: assistenciaPermitidaInput,
			tipoId: tipoIdInput,
			linhaId: linhaIdInput,
			tipoProjeto: tipoProjeto,

			date: [{
				available: dateAvailableInput,
				creation: creationDate,
				modified: is_edit ? currentDateTime : dateModifiedInput,
				published: datePublishedInput,
			}],

			nome: [
				{
					tipo: tipoIdInput,
					linha: linhaIdInput,
					nomeCompleto: getNomeByIds(tipoIdInput, linhaIdInput)
				}
			],

			assistenciaMensal: generateAssistenciaMensal(tempoAssistenciaInput),

		};

		console.log("Dados para post", formData)
		//setTipoProjeto(dados.current.info.tipoProjeto)
		//setCodProjetoInput(dados.current.info.codProjeto);
		//setNLicencaInput(dados.current.info.nLicenca);
		//setSelectedEmpresa(dados.current.info.empresa);
		//setTempoAssistenciaInput(dados.current.info.tempoAssistencia);
		//setAssistenciaRemotaInput(dados.current.info.assistenciaRemota);
		//setAssistenciaPermitidaInput(dados.current.info.assistenciaPermitida);
		//setTipoIdInput(dados.current.info.tipoId);
		//setLinhaIdInput(dados.current.info.linhaId);
		//setDateAvailableInput(dados.current.info.date.available);
		//setDateCreationInput(dados.current.info.date.creation);
		//setDateModifiedInput(dados.current.info.date.modified);
		//setDatePublishedInput(dados.current.info.date.published);

		const updateData = (actionType) => {
			if (is_password) {
				const password = new_password;
				dados.current.info.password = passwordHash(password);
			}

			dados.current.info = { ...dados.current.info, ...formData };

			const request = actionType === 'edit' ? reqPUT : reqPOST;
			request(api_crud_route, dados.current)
				.then(() => {
					set_new_password('');
					set_confirm_password('');

					if (actionType === 'insert') {
						props.history.push(endpoints.list);
					}
				})
				.catch(() => Swal.fire(language[lang][`${actionType}_error`], '', 'info'));
		};

		const confirmationMessage = is_edit ? {
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		} : {
			title: language[lang].insert_title,
			text: language[lang].insert_text,
			confirmButtonText: language[lang].insert_confirm,
			cancelButtonText: language[lang].insert_cancel
		};

		Swal.fire({
			...confirmationMessage,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
		}).then((result) => {
			if (result.isConfirmed) {
				updateData(is_edit ? 'edit' : 'insert');
			}
		});
	};

	function generateAssistenciaMensal(tempoAssistencia) {

		const anoInicial = new Date(dataInicio).getFullYear();
		const anoFinal = new Date(dataFim).getFullYear();
		const mesInicial = new Date(dataInicio).getMonth() + 1;
		const mesFinal = new Date(dataFim).getMonth() + 1;



		for (let year = anoInicial; year <= anoFinal; year++) {

			const startMonth = year === anoInicial ? mesInicial : 1;
			const endMonth = year === anoFinal ? mesFinal : 12;

			for (let month = startMonth; month <= endMonth; month++) {
				assistencia.push({
					ano: year,
					mes: month,
					minutosRestantes: tempoAssistencia,
					tickets: []
				});
			}
		}

		// Limpa os inputs e atualiza o estado
		setHours("");
		setMinutes("");
		setTempoAssistenciaInput("");
		setDataFim("");
		setDataInicio("");

		setAssistencia(assistencia); // Atualiza o estado global
		console.log("Assistencia dentro da funcao", assistencia);
		return assistencia;
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};



	const handleHoursChange = (e) => {
		const newHours = e.target.value;
		setHours(newHours);
		calculateTotalMinutes(newHours, minutes);
	};

	const handleMinutesChange = (e) => {
		const newMinutes = e.target.value;
		setMinutes(newMinutes);
		calculateTotalMinutes(hours, newMinutes);
	};
	const calculateTotalMinutes = (newHours, newMinutes) => {
		// Converte horas e minutos para inteiros e calcula o total em minutos
		const totalMinutes = parseInt(newHours || 0) * 60 + parseInt(newMinutes || 0);
		setTempoAssistenciaInput(totalMinutes); // Atualiza o estado com o total em minutos
	};

	const getEmpresaName = (empresaId) => {
		const found = empresa.find(e => e.id === empresaId);
		return found ? found.nome : 'Unknown Empresa';
	};

	const groupProjectsByCompany = (projetos) => {
		const groupedProjects = {};

		projetos.forEach((projeto) => {
			const empresaName = getEmpresaName(projeto.empresa);

			if (!groupedProjects[empresaName]) {
				groupedProjects[empresaName] = [];
			}
			groupedProjects[empresaName].push(projeto);
		});

		return groupedProjects;
	};

	const groupedProjects = groupProjectsByCompany(projetos);

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">
						{dados.current.id !== '' && dados.info && dados.info.name
							? `${language[lang].entity} - ${dados.info.name}`
							: language[lang].entity
						}
					</h2>
					<p>
						{dados.current.id !== ''
							? language[lang].entity_edit
							: language[lang].entity_new
						}
					</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0" />
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-3">
												<div>
													<table style={tableStyle}>
														<thead>
															<tr>
																<th style={headerCellStyle}>{language[lang].empresa}</th>
																<th style={headerCellStyle}>{language[lang].projetos}</th>
															</tr>
														</thead>
														<tbody>
															{Object.entries(groupedProjects).map(([empresaName, projetos]) => (
																<tr key={empresaName} style={rowStyle}>
																	<td style={cellStyle}>{empresaName}</td>
																	<td style={cellStyle}>
																		<ul style={ulStyle}>
																			{projetos.map((projeto) => (
																				<li key={projeto.id} style={liStyle}>{projeto.name}</li>
																			))}
																		</ul>
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
												<br />
												<div className="row mb-4">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].codProjeto}</label>
														<input
															type="number"
															length="6"
															name="codProjeto"
															value={codProjetoInput || dados.current.info?.codProjeto || ""}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															placeholder={language[lang].codProjeto_placeholder}
															onChange={(e) => setCodProjetoInput(e.target.value)}
															required
														/>
													</div>

													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].licenca}</label>
														<input
															type="number"
															length="6"
															name="nLicenca"
															value={nLicencaInput || dados.current.info?.nLicenca || ""}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															placeholder={language[lang].licenca_placeholder}
															onChange={(e) => setNLicencaInput(e.target.value)}
															required
														/>
													</div>
												</div>

												<div className="row mb-4">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].empresa}</label>
														<select
															name="empresa"
															options={empresa}
															value={selectedEmpresa || dados.current.info?.empresa || ""}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															onChange={(e) => setSelectedEmpresa(e.target.value)}
															required
														>
															<option value="">{language[lang].empresa_placeholder}</option>
															{empresa.map((empresa) => (
																<option key={empresa.id} value={empresa.id}>
																	{empresa.nome}
																</option>
															))}
														</select>
													</div>
												</div>
												<div className="row mb-4">
													{/* <div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].time}</label>
														<input
															type="text"
															name="tempoAssitencia"
															value={tempoAssistenciaInput || dados.current.info?.tempoAssistencia || ""}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															placeholder={language[lang].time}
															onChange={(e) => setTempoAssistenciaInput(parseInt(e.target.value))}
															required
														/>
													</div> */}

													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{"Tipo de Projeto"}</label>
														<select
															className="form-control mb-3"
															value={dados.current.info.tipoProjeto || tipoProjeto}
															placeholder={"Escolha o tipo de assitencia"}
															onChange={(e) => setTipoProjeto(parseInt(e.target.value))}
															style={{ width: '100%' }}
															required
														>
															{tipoPagamento.map((tipo) => (
																<option key={tipo.id} value={tipo.id}>
																	{tipo.nome}
																</option>
															))}
														</select>
													</div>

													<div className="col-md-6" style={{ marginTop: '2%' }}>
														<div className="form-check me-3">
															<input
																type="checkbox"
																className="form-check-input"
																checked={assistenciaRemotaInput || dados.current.info?.assistenciaRemota || false}
																onChange={(e) => setAssistenciaRemotaInput(e.target.checked)}
																id="assistenciaRemota"
															/>
															<label className="form-check-label" htmlFor="assistenciaRemota">
																{language[lang].assistencia_remota}
															</label>
														</div>

														<div className="form-check">
															<input
																type="checkbox"
																className="form-check-input"
																checked={assistenciaPermitidaInput || dados.current.info?.assistenciaPermitida || false}
																onChange={(e) => setAssistenciaPermitidaInput(e.target.checked)}
																id="assistenciaPermitida"
															/>
															<label className="form-check-label" htmlFor="assistenciaPermitida">
																{language[lang].assistencia_permitida}
															</label>
														</div>
													</div>

													{(dados.current.info.tipoProjeto == 2 || tipoProjeto == 2) && (
														<div className="d-flex flex-column">
															<div className="row mb-3">
																<div className="col-md-6">
																	<label className="fs-5 fw-bold mb-2">{language[lang].time}</label>
																	<div className="d-flex align-items-center">
																		<input
																			type="number"
																			name="hours"
																			value={hours || ""}
																			className="form-control form-control-lg rounded-0 input-spacing me-2"
																			placeholder="Horas"
																			min="0"
																			onChange={handleHoursChange}
																		/>
																		<span className="mx-2">:</span>
																		<input
																			type="number"
																			name="minutes"
																			value={minutes || ""}
																			className="form-control form-control-lg rounded-0 input-spacing ms-2"
																			placeholder="Minutos"
																			min="0"
																			max="59"
																			onChange={handleMinutesChange}
																		/>
																	</div>
																</div>
															</div>

															<div className="row mb-3">
																<div className="col-md-6">
																	<label className="fs-5 fw-bold mb-2">{"Início"}</label>
																	<input
																		type="date"
																		className="form-control"
																		value={dataInicio || ""}
																		onChange={(e) => setDataInicio(e.target.value)}
																	/>
																</div>
																<div className="col-md-6">
																	<label className="fs-5 fw-bold mb-2">{language[lang].data_disponivel}</label>
																	<input
																		type="date"
																		className="form-control"
																		value={dataFim || ""}
																		onChange={(e) => setDataFim(e.target.value)}
																	/>
																</div>
															</div>

															<div className="row align-items-end">
																<div className="col-md-12 text-end">
																	<button className="btn btn-primary" onClick={adicionarAssistencia}>
																		{language[lang].add_assist}
																	</button>
																</div>
															</div>

															<div className="row mt-4">
																<div className="col-md-7">
																	{assistencia.length > 0 ? (
																		<div>
																			<h3 className="mb-3">{language[lang].resume}</h3>
																			<table className="table table-bordered">
																				<thead>
																					<tr>
																						<th>#</th>
																						<th>{language[lang].ano}</th>
																						<th>{language[lang].time_minutes}</th>
																						<th>{language[lang].time_hours}</th>
																					</tr>
																				</thead>
																				<tbody>
																					{Array.from(
																						assistencia.reduce((map, item) => {
																							if (!map.has(item.ano)) {
																								map.set(item.ano, item.minutosRestantes);
																							} else {
																								map.set(item.ano, map.get(item.ano) + item.minutosRestantes);
																							}
																							return map;
																						}, new Map())
																					).map(([ano, minutosRestantes], index) => (
																						<tr key={index}>
																							<td>{index + 1}</td>
																							<td>{ano || "N/A"}</td>
																							<td>{minutosRestantes || 0}</td>
																							<td>{((minutosRestantes || 0) / 60).toFixed(2)} {language[lang].hours}</td>
																						</tr>
																					))}
																				</tbody>
																			</table>
																		</div>
																	) : (
																		<p className="text-end mt-3">{language[lang].no_assist}</p>
																	)}
																</div>
															</div>

														</div>
													)}
												</div>

												<div className="row mb-4">
													<div className="col-md-6">
														<div className="mb-3">
															<label className="fs-5 fw-bold mb-2">{language[lang].software_line}</label>
															<select
																className="form-control mb-3"
																value={tipoIdInput}
																placeholder={language[lang].software_line_placeholder}
																onChange={(e) => setTipoIdInput(parseInt(e.target.value))}
																style={{ width: '100%' }}
																required
															>
																{tipoSw.map((tipo) => (
																	<option key={tipo.id} value={tipo.id}>
																		{tipo.nome}
																	</option>
																))}
															</select>
														</div>
														<div className="mb-3">
															<label className="fs-5 fw-bold mb-2">{language[lang].software_type}</label>
															<select
																className="form-control mb-3"
																value={linhaIdInput}
																placeholder={language[lang].software_type_placeholder}
																onChange={(e) => setLinhaIdInput(parseInt(e.target.value))}
																style={{ width: '100%' }}
																required
															>
																{linhaSw.map((linha) => (
																	<option key={linha.id} value={linha.id}>
																		{linha.nome}
																	</option>
																))}
															</select>
														</div>
													</div>

													<div className="col-md-6">
														<div className="mb-3">
															<label className="fs-5 fw-bold mb-2">{language[lang].data}</label>
															<input
																type="date"
																className="form-control mt-2"
																value={datePublishedInput || dados.current.info.date?.published || ""}
																onChange={(e) => setDatePublishedInput(e.target.value)}
																style={{ width: '100%' }}
															/>
														</div>

														<div className="mb-3">
															<label className="fs-5 fw-bold mb-2">{language[lang].data_disponivel}</label>
															<input
																type="date"
																className="form-control mt-2"
																value={dateAvailableInput || dados.current.info.date?.available || ""}
																onChange={(e) => setDateAvailableInput(e.target.value)}
																style={{ width: '100%' }}
															/>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div >

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
